import React from 'react'

import { Grid as BaseGrid, Divider as DividerBase, styled } from '@mui/material'

export const Divider = styled(({ ...props }) => <DividerBase {...props} />)``
export const Grid = styled(({ ...props }) => <BaseGrid {...props} />)`
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  width: 100%;
`

export const Row = styled('div')`
  text-align: right;
  width: 100%;
`
export const Label = styled('span')`
  color: ${props => props.theme.palette.red[50]};
  font-weight: bold;
`
export const Strong = styled('span')`
  font-weight: bold;
  color: ${props => props?.black && props.theme.palette.brand.black1};
`
